<template>
  <div class="list mb-10">
    <v-row>
      <v-col class="d-flex justify-start">
      </v-col>
    </v-row>
    <h4>{{ $t("manage.by_admin.header") }}</h4>
    <v-tabs
      v-model="tab"
      class="elevation-2"
      flat
    > 
      <v-tab :href="`#tab-schools`">
        {{ $t("manage.by_admin.tab.schools") }}
      </v-tab>
      <v-tab :href="`#tab-experiments`">
        {{ $t("manage.by_admin.tab.experiments") }}
      </v-tab>      
      <v-tab :href="`#tab-announcements`">
        {{ $t("manage.by_admin.tab.announcements") }}
      </v-tab>
      <v-tab :href="`#tab-documents`">
        {{ $t("manage.by_admin.tab.documents") }}
      </v-tab>
      <v-tab :href="`#tab-bookings`">
        {{ $t("manage.by_admin.tab.bookings") }}
      </v-tab>
      <v-tab-item :value="'tab-schools'">
        <Schools />
      </v-tab-item>
      <v-tab-item :value="'tab-experiments'">
        <Experiments />
      </v-tab-item>
      <v-tab-item :value="'tab-announcements'">
        <Announcements />
      </v-tab-item>
      <v-tab-item :value="'tab-documents'">
        <Documents />
      </v-tab-item>
      <v-tab-item :value="'tab-bookings'">
        <Bookings />
      </v-tab-item>
    </v-tabs>
  </div>
</template>
<script>
import Schools from "@/components/management/list/Schools.vue";
import Experiments from "@/components/management/list/Experiments.vue";
import Announcements from "@/components/management/list/Announcements.vue";
import Documents from "@/components/management/list/Documents.vue";
import Bookings from "@/components/management/list/Bookings.vue";

import {api_general} from '@/services/iot/api_general';
const apiGeneral = new api_general(process.env.VUE_APP_BASE_URL);
export default {
  name: "admin",
  components: {
    Schools,
    Experiments,
    Announcements,
    Documents,
    Bookings,
  },
  data: () => ({
    tab: null,
    school_id: null,
    api: {
      school: null,
    },
  }),
  mounted() {
    var self = this;
    self.school_id = self.$route.params.school_id;
    let tmp = self.$route.hash.split("#").pop();
    if(tmp!="" || tmp!="tab-user" || tmp!="tab-experiment"){
      self.tab = tmp;
    }
    if(self.$store.state.user.user_level!="ADMIN"){
      self.userSchoolVerify();
    }
/*    if($cookies.get('username') != "admin"){
        self.$store.commit('showSnackBar', "Access Denied");
        self.$router.push("/");
    }
*/
  },
  methods: {
    userSchoolVerify(){
      var self = this;
      apiGeneral.userSchoolVerify(self.$cookies.get('username'), self.school_id)
      .then((response) => {
        if(response.status=="fail"){
          alert(response.error);
        }
        else if(response.status=="success"){
          ;
        }
      });
    },
  }
};
</script>